// extracted by mini-css-extract-plugin
module.exports = {"siteNotificationCookieUsage":"CookieUsage_siteNotificationCookieUsage__XqGQd","link":"CookieUsage_link__1WA2q","btnSuccess":"CookieUsage_btnSuccess__Prozu"};